'use client';
import dynamic from 'next/dynamic';

import Guard from '@/components/permission/Guard';
import SpinnerLoading from '@/components/SpinnerLoading';
import useUserRole from '@/hooks/useUserRole';
import { routeManager } from '@/utils/route';

const Dashboard = dynamic(() => import('../dashboard'), {
    ssr: false,
    loading: () => <SpinnerLoading />,
});

const CustomerViewTab = dynamic(() => import('../khach-hang/view'), {
    ssr: false,
    loading: () => <SpinnerLoading />,
});

const StaffViewTab = dynamic(() => import('../nhan-vien/view'), {
    ssr: false,
    loading: () => <SpinnerLoading />,
});

const VIEW_MAP = {
    [routeManager.HOME]: Dashboard,
    [routeManager.CUSTOMER_DETAIL]: CustomerViewTab,
    [routeManager.STAFF_DETAIL]: StaffViewTab,
};

const DefaultPage = () => {
    const roleType = useUserRole().roleType;

    const info = roleType?.getInformationHomeRoute();

    if (!info) return null;

    const Component = VIEW_MAP[info.routeKey];

    if (!Component) return <div>Không tìm thấy route phù hợp</div>;

    return (
        <Guard routeKey={info.routeKey}>
            <Component {...info.params} id={info.params.id || ''} />
        </Guard>
    );
};

export default DefaultPage;
